import { QASTutorials } from "./QASTutorials";
import { QESTutorials } from "./QESTutorials";
import TutorialsRouter from "./TutorialsRouter";
import TutorialsService from "./tutorialsService";

export {
  TutorialsRouter,
  TutorialsService,
  QASTutorials,
  QESTutorials,
};
